module.exports = __webpack_public_path__ + "img/waterlilly.9e0286cf.jpg";